export default {
  light: {
    primary: '#DAE1E9',
    secondary: '#8392A7',
    line1: '#DAE1E9',
    green: '#5EBE5E',
  },
  dark: {
    primary: '#848484',
    primaryCard: '#8392A7',
    line1: '#8392A7',
  },
};
